export default __webpack_public_path__ + "static/media/skeleton.dbbb2884.gif";